// extracted by mini-css-extract-plugin
module.exports = {"placement_drawer":"CartButton_placement_drawer__zpO0V","cartCountText":"CartButton_cartCountText__9LkJv","button":"CartButton_button__NPx4z"};